<template>
  <button :disabled="isDisabled">
    <SvgIcon
      :name="type === 'prev' ? 'chevron-left' : 'chevron-right'"
    ></SvgIcon>
  </button>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    default: 'prev',
    validate: (value) => ['prev', 'next'].includes(value),
  },
  isDisabled: { type: Boolean, default: false },
});
</script>
